/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MasterScheduleAllocationDetailResponse } from '../../models/master-schedule-allocation-detail-response';

export interface GetMasterScheduleAllocation$Params {
  id: number;
}

export function getMasterScheduleAllocation(http: HttpClient, rootUrl: string, params: GetMasterScheduleAllocation$Params, context?: HttpContext): Observable<StrictHttpResponse<MasterScheduleAllocationDetailResponse>> {
  const rb = new RequestBuilder(rootUrl, getMasterScheduleAllocation.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MasterScheduleAllocationDetailResponse>;
    })
  );
}

getMasterScheduleAllocation.PATH = '/api/scheduler/master-schedule/allocations/{id}';
